export default {
  state: {
    modalStack: [],
  },
  mutations: {
    pushModal(state, modal) {
      if (state.modalStack[state.modalStack.length - 1]) {
        const m = document.getElementById(state.modalStack[state.modalStack.length - 1]);
        if (m) {
          m.style.overflow = 'hidden';
        }
      }
      state.modalStack.push(modal);
    },
    popModal(state) {
      state.modalStack.pop();
      if (state.modalStack[state.modalStack.length - 1]) {
        const m = document.getElementById(state.modalStack[state.modalStack.length - 1]);
        if (m) {
          m.style.overflow = '';
        }
      }
    },
  },
  actions: {
    pushModal(context, modal) {
      context.commit('pushModal', modal);
    },
    popModal(context) {
      context.commit('popModal');
    },
  },
};
